import { ApexOptions } from 'apexcharts';

export enum STOCK_OPERATION {
  DISCOUNTED = 'DISCOUNTED',
  ADDED = 'ADDED',
  SOLD = 'SOLD',
  REFOUND = 'REFOUND',
  RETURN_AS_DAMAGED = 'RETURN_AS_DAMAGED',
  EXCHANGE = 'EXCHANGE',
  REPLACE_FOR_REFUND = 'REPLACE_FOR_REFUND',
}

export interface IChartProps {
  values: ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
  labels: string[];
  colors: string[];
  isLoading?: boolean;
  title: string;

  optionProps?: ApexOptions;
}
